// Rwanda & Kilimanjaro tour package data — extracted from RwandaSafari.js so it can be
// imported without pulling the full component into the main bundle.
export const tourData = {
  "tour_packages": [
    {
      "tour_code": "JT046",
      "name": "Two Nights/Three Days Gorillas in the Midst",
      "destination": "Rwanda",
      "duration": {
        "nights": 2,
        "days": 3
      },
      "highlight": "Mountain Gorilla Tracking",
      "coverImage": "https://plus.unsplash.com/premium_photo-1686232985330-40371058c024?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bW91bnRhaW4lMjBnb3JpbGxhJTIwdHJhY2tpbmd8ZW58MHx8MHx8fDA%3D",
      "itinerary": [
        {
          "day": 1,
          "location": "Kigali",
          "accommodation": "Novotel Umubano/Kigali Serena",
          "board": "BB",
          "activities": ["Flight Transfer", "City Tour", "Genocide Memorial Museum Visit", "Leisure"]
        },
        {
          "day": 2,
          "location": "Ruhengeri/Kigali",
          "accommodation": "Novotel Umubano/Kigali Serena",
          "board": "L-BB",
          "activities": ["Gorilla Trekking", "Visit Twin Lakes Butera & Ruhondo"]
        },
        {
          "day": 3,
          "location": "Departure",
          "activities": ["Transfer to Airport", "Departure Flight"]
        }
      ],
      "description": "Visit the mountain gorilla population in Parc National des Volcans, currently with only 700 individuals remaining."
    },
    {
      "tour_code": "JT047",
      "name": "Three Nights/Four Days Gorillas in the Midst",
      "destination": "Rwanda",
      "duration": {
        "nights": 3,
        "days": 4
      },
      "highlight": "Mountain Gorilla Tracking",
      "coverImage": "https://plus.unsplash.com/premium_photo-1685785838718-77489a5fbf74?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8bW91bnRhaW4lMjBnb3JpbGxhJTIwdHJhY2tpbmd8ZW58MHx8MHx8fDA%3D",
      "itinerary": [
        {
          "day": 1,
          "location": "Kigali",
          "accommodation": "Novotel Umubano/Kigali Serena",
          "board": "BB",
          "activities": ["Flight Transfer", "City Tour", "Genocide Memorial Museum Visit", "Leisure"]
        },
        {
          "day": 2,
          "location": "Ruhengeri/Kigali",
          "accommodation": "Gorilla Mountain View Lodge",
          "board": "",
          "activities": ["Gorilla Trekking", "Visit Twin Lakes"]
        },
        {
          "day": 3,
          "location": "Ruhengeri/Kigali",
          "accommodation": "Novotel Umubano/Kigali Serena",
          "board": "L-BB",
          "activities": ["Second Gorilla Trekking", "Different Gorilla Family"]
        },
        {
          "day": 4,
          "location": "Departure",
          "activities": ["Transfer to Airport", "Departure Flight"]
        }
      ],
      "description": "Extended gorilla tracking experience with visits to different gorilla families in Parc National des Volcans."
    },
    {
      "tour_code": "JT045",
      "name": "Classic Rwanda Safari",
      "destination": "Rwanda",
      "duration": {
        "nights": 5,
        "days": 6
      },
      "highlight": "Chimps and Gorilla Tracking",
      "coverImage": "https://images.unsplash.com/photo-1639771496050-26aa74df339e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fHJ3YW5kYXxlbnwwfHwwfHx8MA%3D%3D",
      "itinerary": [
        {
          "day": 1,
          "location": "Nyungwe",
          "accommodation": "Gisakura Guest House",
          "board": "LDBB",
          "activities": ["Flight Transfer", "Visit Butare", "King's Palace", "National Museum"]
        },
        {
          "day": 2,
          "location": "Nyungwe",
          "accommodation": "Gisakura Guest House",
          "board": "LDBB",
          "activities": ["Chimpanzee and Primate Tracking", "Tea Plantation Visit"]
        },
        {
          "day": 3,
          "location": "Lake Kivu",
          "accommodation": "Lake Kivu Serena",
          "board": "LDBB",
          "activities": ["Second Chimp Tracking Attempt", "Drive to Lake Kivu"]
        },
        {
          "day": 4,
          "location": "Ruhengeri/Kinigi",
          "accommodation": "Gorilla Mountain View Lodge",
          "board": "LDBB",
          "activities": ["Leisure at Lake", "Drive to Ruhengeri"]
        },
        {
          "day": 5,
          "location": "Kigali",
          "accommodation": "Novotel Umubano/Kigali Serena",
          "board": "L-BB",
          "activities": ["Gorilla Tracking", "Twin Lakes Visit", "Drive to Kigali"]
        },
        {
          "day": 6,
          "location": "Departure",
          "activities": ["Transfer to Airport", "Departure Flight"]
        }
      ],
      "description": "Comprehensive safari combining chimps in Nyungwe Forest, Lake Kivu, and mountain gorillas in Virunga Mountains."
    },
    {
      "tour_code": "JT044",
      "name": "Machame Route",
      "destination": "Tanzania",
      "duration": {
        "nights": 7,
        "days": 8
      },
      "highlight": "Kilimanjaro Climbing",
      "coverImage": "https://images.unsplash.com/photo-1546422560-9a00391b9278?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjR8fHJ3YW5kYXxlbnwwfHwwfHx8MA%3D%3D",
      "itinerary": [
        {
          "day": 1,
          "location": "Moshi",
          "accommodation": "Springland Hotel/Similar",
          "board": "DBB",
          "activities": ["Transfer from Nairobi/Arusha", "Pre-climb Briefing"]
        },
        {
          "day": 2,
          "location": "Machame",
          "accommodation": "Machame Camp",
          "board": "LDBB",
          "activities": ["Begin Climb through Rainforest", "5-6 Hour Trek"]
        },
        {
          "day": 3,
          "location": "Shira",
          "accommodation": "Shira Camp",
          "board": "LDBB",
          "activities": ["6 Hour Ascent", "Reach 3800m Altitude"]
        },
        {
          "day": 4,
          "location": "Barranco",
          "accommodation": "Barranco Camp",
          "board": "LDBB",
          "activities": ["Climb to Lava Tower", "Descent to Barranco Valley"]
        },
        {
          "day": 5,
          "location": "Barafu",
          "accommodation": "Barafu Camp",
          "board": "LDBB",
          "activities": ["Climb Barranco Wall", "6-7 Hour Trek", "Night Summit Preparation"]
        },
        {
          "day": 6,
          "location": "Mweka",
          "accommodation": "Mweka Camp",
          "board": "LDBB",
          "activities": ["Early Summit Attempt", "Reach Uhuru Peak (5895m)", "Descent via Stella Point"]
        },
        {
          "day": 7,
          "location": "Moshi",
          "accommodation": "Springland Hotel/Similar",
          "board": "DBB",
          "activities": ["Final Descent", "Certificate Collection", "Return to Hotel"]
        },
        {
          "day": 8,
          "location": "Departure",
          "activities": ["Transfer to Airport", "Departure"]
        }
      ],
      "description": "Popular and scenic Kilimanjaro climbing route via Machame with good acclimatization profile."
    },
    {
      "tour_code": "JT043",
      "name": "Marangu Route",
      "destination": "Tanzania",
      "duration": {
        "nights": 6,
        "days": 7
      },
      "highlight": "Kilimanjaro Climbing",
      "coverImage": "https://images.unsplash.com/photo-1689996821865-587203fecd9a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTN8fGtpbGltYW5qYXJvfGVufDB8fDB8fHww",
      "itinerary": [
        {
          "day": 1,
          "location": "Moshi",
          "accommodation": "Springland Hotel/Similar",
          "board": "DBB",
          "activities": ["Transfer from Nairobi/Arusha", "Pre-climb Briefing"]
        },
        {
          "day": 2,
          "location": "Mandara",
          "accommodation": "Mandara Hut",
          "board": "LDBB",
          "activities": ["Drive to Marangu Gate", "5 Hour Forest Trek"]
        },
        {
          "day": 3,
          "location": "Horombo",
          "accommodation": "Horombo Hut",
          "board": "LDBB",
          "activities": ["Trek through Moorland", "6 Hour Walk"]
        },
        {
          "day": 4,
          "location": "Kibo",
          "accommodation": "Kibo Hut",
          "board": "LDBB",
          "activities": ["Cross Alpine Desert", "Acclimatization Day"]
        },
        {
          "day": 5,
          "location": "Horombo",
          "accommodation": "Horombo Hut",
          "board": "LDBB",
          "activities": ["Midnight Summit Attempt", "Reach Uhuru Peak (5895m)", "Descent to Horombo"]
        },
        {
          "day": 6,
          "location": "Moshi",
          "accommodation": "Springland Hotel/Similar",
          "board": "DBB",
          "activities": ["Descent to Marangu Gate", "Certificate Collection", "Return to Hotel"]
        },
        {
          "day": 7,
          "location": "Departure",
          "activities": ["Transfer to Airport", "Departure"]
        }
      ],
      "description": "The easiest and most popular route up Kilimanjaro with hut accommodations along the way."
    },
    {
      "tour_code": "JT048",
      "name": "Rwanda Gorilla Trekking",
      "destination": "Rwanda",
      "duration": {
        "nights": 3,
        "days": 4
      },
      "highlight": "Mountain Gorilla Tracking",
      "coverImage": "https://images.unsplash.com/photo-1658012756033-f7e3313341c2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDd8fG1vdW50YWluJTIwZ29yaWxsYSUyMHRyYWNraW5nfGVufDB8fDB8fHww",
      "description": "Specialized eco-friendly gorilla trekking safaris with professional guides in the Virunga Mountains, where gorillas share 97% of our DNA. Tracking may take up to 2-4 hours with viewing time limited to one hour per visit.",
      "itinerary": [
        {
          "day": 1,
          "location": "Kigali",
          "accommodation": "Kigali Serena",
          "board": "BB",
          "activities": ["Airport Transfer", "City Tour", "Cultural Experience"]
        },
        {
          "day": 2,
          "location": "Volcanoes National Park",
          "accommodation": "Gorilla Mountain View Lodge",
          "board": "FB",
          "activities": ["Transfer to Park", "Park Briefing", "Nature Walks"]
        },
        {
          "day": 3,
          "location": "Volcanoes National Park",
          "accommodation": "Gorilla Mountain View Lodge",
          "board": "FB",
          "activities": ["Gorilla Trekking", "Cultural Village Visit"]
        },
        {
          "day": 4,
          "location": "Departure",
          "activities": ["Return to Kigali", "Departure Flight"]
        }
      ]
    },
    {
      "tour_code": "JT049",
      "name": "Kilimanjaro Climbing - Alternative Routes",
      "destination": "Tanzania",
      "duration": {
        "nights": 6,
        "days": 7
      },
      "highlight": "Kilimanjaro Climbing",
      "coverImage": "https://images.unsplash.com/photo-1631646109206-4b5616964f84?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODJ8fGtpbGltYW5qYXJvJTIwdGFuemFuaWF8ZW58MHx8MHx8fDA%3D",
      "description": "Mount Kilimanjaro stands at 5,895 meters and features six routes: Marangu, Machame, Shira, Rongai, Lemosho, and the Northern Circuit. The mountain has three volcanic cones: Kibo (5,895m), Mawenzi (5,149m), and Shira (3,962m).",
      "itinerary": [
        {
          "day": 1,
          "location": "Moshi",
          "accommodation": "Mountain Hotel",
          "board": "BB",
          "activities": ["Airport Transfer", "Equipment Check", "Briefing"]
        },
        {
          "day": 2,
          "location": "First Camp",
          "accommodation": "Mountain Camp",
          "board": "FB",
          "activities": ["Begin Trek", "Forest Zone"]
        },
        {
          "day": 3,
          "location": "Second Camp",
          "accommodation": "Mountain Camp",
          "board": "FB",
          "activities": ["Ascent", "Acclimatization"]
        },
        {
          "day": 4,
          "location": "High Camp",
          "accommodation": "Mountain Camp",
          "board": "FB",
          "activities": ["High Altitude Trek", "Summit Preparation"]
        },
        {
          "day": 5,
          "location": "Summit Day",
          "accommodation": "Descent Camp",
          "board": "FB",
          "activities": ["Summit Push", "Reach Uhuru Peak", "Begin Descent"]
        },
        {
          "day": 6,
          "location": "Moshi",
          "accommodation": "Mountain Hotel",
          "board": "BB",
          "activities": ["Final Descent", "Certificate Ceremony"]
        },
        {
          "day": 7,
          "location": "Departure",
          "activities": ["Airport Transfer", "Departure"]
        }
      ]
    }
  ],
  "gorilla_tracking_info": {
    "location": "Parc National des Volcans (Volcanoes National Park)",
    "distance_from_kigali": "91 km NW (2 hours drive)",
    "gorilla_population": "Approximately 700 individuals",
    "altitude_range": "3500m - 4507m",
    "habituated_families": 4,
    "visitor_limitations": {
      "people_per_family": 8,
      "total_daily_visitors": 32
    },
    "visit_rules": [
      "No spitting in the park",
      "No littering",
      "No coughing in direction of gorillas",
      "Only speak in whispers",
      "Do not point at gorillas",
      "Maintain 7m distance from gorillas",
      "No consuming food near gorillas",
      "If you get close to a gorilla, sit very still",
      "If a gorilla charges, do not look directly at it",
      "Stand perfectly still until the guide asks you to move back"
    ],
    "essentials": [
      "Long pants",
      "Good hiking boots",
      "Light waterproof coat",
      "Cap/hat",
      "Camera (no flash)",
      "Drinking water"
    ]
  }
};

export const rwandaPackages = tourData.tour_packages;
